import './sentry-init'
import { createRoot } from 'react-dom/client'
import App from '~/app/index.tsx'

createRoot(document.getElementById('root') as HTMLElement).render(<App />)
